import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, deleteDoc } from "firebase/firestore";
import { db } from '../../firebase';
import { FaPen, FaTrashAlt } from 'react-icons/fa';
import ConfirmDialog from '../Dialog/ConfirmDialog';
import EditEventModal from '../Dialog/EditEventModal';

function EventListItem({ event, user, onDeleted, onUpdated }) {

  const [confirmOpen, setConfirmOpen] = useState(false);
   const [editOpen, setEditOpen] = useState(false);
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      const eventDocRef = doc(db, 'events', event.id);
      await deleteDoc(eventDocRef);
      if (typeof onDeleted === 'function') {
        onDeleted(event.id);
      }
      setConfirmOpen(false); 
    } catch (error) {
      
    }
  };


  const handleEdit = () => {
    setEditOpen(true);
  };

  const handleModalClose = (updated) => {
    setEditOpen(false);
    if (updated && typeof onUpdated === 'function') {
      onUpdated();
    }
  };

  const dateObj = event.date && event.date.seconds
    ? new Date(event.date.seconds * 1000)
    : null;

  if (!dateObj) return <div>Invalid Date</div>;

  const day = dateObj.getDate();
  const monthLong = dateObj.toLocaleString('default', { month: 'long' });
  const monthShort = dateObj.toLocaleString('default', { month: 'short' }).toUpperCase();
  const year = dateObj.getFullYear();

  const hours = dateObj.getHours().toString().padStart(2, '0');
  const minutes = dateObj.getMinutes().toString().padStart(2, '0');
  const time = `${hours}:${minutes}`;

  return (
    <div className="event-list-item">
      <div className="event-date-box">
        <span className="event-day">{day}</span>
        <span className="event-month">{monthShort}</span>
        <span className="event-year">{year}</span>
      </div>
      <div className="event-image-box">
        <img src={event.image} alt={event.name} className="event-img" />
      </div>
      <div className="event-details">
        <h3>{event.name}</h3>
        <p>{day} {monthLong} {year} | {time}</p>
        <p>{event.description}</p>
        {Number(event.costPerPerson) > 0 && (
          <p>€ {event.costPerPerson}</p>
        )}

        <button
          className="read-more-btn"
          onClick={() => navigate(`/event/${event.id}`)}
        >
          Read More
        </button>
        {event.expired && <span className="event-expired">Event has expired.</span>}
      </div>
      {user && (
        <div className="event-controls">
          <button 
          className="edit-icon-btn" 
          onClick={handleEdit} 
          title="Edit event"> 
          <FaPen />
          </button>
          <button 
          className="delete-icon-btn" 
          onClick={() => setConfirmOpen(true)}
          title="Delete event"> 
          <FaTrashAlt />
          </button>

          <ConfirmDialog
            open={confirmOpen}
            title="Confirm Deletion"
            message="Are you sure you want to delete this event?"
            onConfirm={handleDelete}
            onCancel={() => setConfirmOpen(false)}
          />

          <EditEventModal
            open={editOpen}
            onClose={handleModalClose}
            event={event}
          />
        </div>
      )}
    </div>
  );
}

export default EventListItem;